const BG_RED = '#f984ff'
const BG_GREEN = '#4dc5b9'
const BG_YELLOW = '#ffb872'
const BG_ORANGE = '#FFB872'
const BG_BLUE = '#1296db'
const BG_LIGHT_BLUE = '#44CBCA'
import Vuex from '@/store'
import { $t as lang } from '@/Tool'
export const mockMenu = {
  system: [
    // {
    //   icon: 'iconfont icon-kaihuguanli2',
    //   title: lang('mainMenu.myMenu.openAccount'),
    //   bgColor: BG_RED,
    //   key: 'newAcount',
    //   url: '/uc/newAcount',
    //   child: [],
    //   parentKey: 'system',
    //   label: lang('mainMenu.myMenu.openAccount'),
    //   visible: true,
    // },
    {
      icon: 'iconfont icon-kaihuguanli2',
      title: lang('mainMenu.myMenu.agentManagement'),
      bgColor: BG_RED,
      key: 'agentManagement',
      url: '/vshow/agentManagement',
      child: [],
      parentKey: 'system',
      label: lang('mainMenu.myMenu.agentManagement'),
      visible: true,
    },
    {
      icon: 'iconfont icon-kaihuguanli2',
      title: lang('mainMenu.myMenu.userManagement'),
      bgColor: BG_RED,
      key: 'userManagement',
      url: '/vshow/userManagement',
      child: [],
      parentKey: 'system',
      label: lang('mainMenu.myMenu.userManagement'),
      visible: true,
    },
    {
      icon: 'iconfont icon-kaihuguanli2',
      title: lang('mainMenu.myMenu.basicInfo'),
      bgColor: BG_RED,
      key: 'scrmAccountSetting',
      url: '/accountSetting',
      child: [],
      parentKey: 'system',
      label: lang('mainMenu.myMenu.basicInfo'),
      visible: true,
    },
    //钻石充值
    // {
    //   icon: 'iconfont icon-zuanshichongzhi',
    //   title: lang("mainMenu.myMenu.diamondTopUp"),
    //   bgColor: BG_BLUE,
    //   key: 'diamondTopUp',
    //   url: '/vshow/diamondTopUp',
    //   child: [],
    //   parentKey: 'system',
    //   label: lang("mainMenu.myMenu.diamondTopUp"),
    //   visible: true,
    // },
    {
      icon: 'iconfont icon-dingdanguanli',
      title: lang('mainMenu.myMenu.myOrder'),
      bgColor: BG_GREEN,
      key: 'videoOrder',
      url: '/vshow/videoOrder',
      child: [],
      parentKey: 'system',
      label: lang('mainMenu.myMenu.myOrder'),
      visible: true,
    },
    {
      icon: 'iconfont icon-shichangxiaohao',
      title: lang('mainMenu.myMenu.consumption'),
      bgColor: BG_GREEN,
      key: 'consumption',
      url: '/vshow/consumption',
      child: [],
      parentKey: 'system',
      label: lang('mainMenu.myMenu.consumption'),
      visible: true,
    },
    // {
    //   icon: 'iconfont icon-zhanghaoguanli2',
    //   title: lang('mainMenu.myMenu.accountManagement'),
    //   bgColor: BG_YELLOW,
    //   key: 'accountManage',
    //   url: '/uc/accountManage',
    //   child: [],
    //   parentKey: 'system',
    //   label: lang('mainMenu.myMenu.accountManagement'),
    //   visible: true,
    // },
    // 新账号管理
    {
      icon: 'iconfont icon-zhanghaoguanli2',
      title: lang('mainMenu.myMenu.accountManagement'),
      bgColor: BG_YELLOW,
      key: 'accountManage',
      url: '/vshow/accountManage',
      child: [],
      parentKey: 'system',
      label: lang('mainMenu.myMenu.accountManagement'),
      visible: true,
    },
    {
      icon: 'iconfont icon-quanxianguanli2',
      title: lang('mainMenu.myMenu.authManagement'),
      bgColor: BG_LIGHT_BLUE,
      key: 'authManage',
      url: '/vshow/authManage',
      child: [],
      parentKey: 'system',
      label: lang('mainMenu.myMenu.authManagement'),
      visible: true,
    },
    {
      icon: 'iconfont icon-xiaoxizhongxin',
      title: lang('mainMenu.myMenu.messageCenter'),
      bgColor: BG_YELLOW,
      key: 'messageCenter',
      url: '/messageCenter',
      child: [],
      parentKey: 'system',
      label: lang('mainMenu.myMenu.messageCenter'),
      visible: true,
    },
  ],
  // data: [
  //   {
  //     icon: 'iconfont icon-quanxianguanli2',
  //     title: '小知识',
  //     bgColor: BG_RED,
  //     key: 'dataKnowledge',
  //     url: '/scrm-datacenter/viKnowledge',
  //     child: [],
  //     parentKey: 'data',
  //     label: '小知识',
  //     visible: true,
  //   },
  //   {
  //     icon: 'iconfont icon-kehuguanli2',
  //     title: '客户',
  //     bgColor: BG_GREEN,
  //     key: 'dataCustomer',
  //     url: '/scrm-datacenter/viCustomer',
  //     child: [],
  //     parentKey: 'data',
  //     label: '客户',
  //     visible: true,
  //   },
  // ],
  // workBench: [
  //   {
  //     icon: 'iconfont icon-wodemote',
  //     title: lang('mainMenu.workBench.myModel'),
  //     bgColor: BG_RED,
  //     key: 'myModel',
  //     url: '/vshow/workBench/myModel',
  //     child: [],
  //     parentKey: 'workBench',
  //     label: lang('mainMenu.workBench.myModel'),
  //     visible: true,
  //   },
  //   {
  //     icon: 'iconfont icon-wodemoban',
  //     title: lang('mainMenu.workBench.myTemplate'),
  //     bgColor: BG_BLUE,
  //     key: 'myTemplate',
  //     url: '/vshow/workBench/myTemplate',
  //     child: [],
  //     parentKey: 'workBench',
  //     label: lang('mainMenu.workBench.myTemplate'),
  //     visible: true,
  //   },
  //   {
  //     icon: 'iconfont icon-wodeshengyinmoxing',
  //     title: lang('mainMenu.workBench.myVoiceModel'),
  //     bgColor: BG_GREEN,
  //     key: 'myTTS',
  //     url: '/vshow/workBench/myTTS',
  //     child: [],
  //     parentKey: 'workBench',
  //     label: lang('mainMenu.workBench.myVoiceModel'),
  //     visible: true,
  //   },
  //   {
  //     icon: 'iconfont icon-wodetaiben',
  //     title: lang('mainMenu.workBench.myDrama'),
  //     bgColor: BG_YELLOW,
  //     key: 'myScript',
  //     url: '/vshow/workBench/myScript',
  //     child: [],
  //     parentKey: 'workBench',
  //     label: lang('mainMenu.workBench.myDrama'),
  //     visible: true,
  //   },
  //   {
  //     icon: 'iconfont icon-wodezhibo',
  //     title: lang('mainMenu.workBench.myLive'),
  //     bgColor: BG_RED,
  //     key: 'myLive',
  //     url: '/dh-live-room/record',
  //     child: [],
  //     parentKey: 'workBench',
  //     label: lang('mainMenu.workBench.myLive'),
  //     visible: true,
  //   },
  // ],
  knowledgeManage: [
    {
      icon: 'iconfont icon-shipin',
      title: lang('mainMenu.workManagement.videoWorks'),
      bgColor: BG_RED,
      key: 'videoCreation',
      url: '/vshow/creations/video',
      child: [],
      parentKey: 'knowledgeManage',
      label: lang('mainMenu.workManagement.videoWorks'),
      visible: true,
    },
    {
      icon: 'iconfont icon-yinpin',
      title: lang('mainMenu.workManagement.voiceWorks'),
      bgColor: BG_GREEN,
      key: 'audioCreation',
      url: '/vshow/creations/audio',
      child: [],
      parentKey: 'knowledgeManage',
      label: lang('mainMenu.workManagement.voiceWorks'),
      visible: true,
    },
    // {
    //   icon: 'iconfont icon-huihuaguanli',
    //   title: lang('mainMenu.workManagement.drawWorks'),
    //   bgColor: BG_ORANGE,
    //   key: 'aiPainting',
    //   url: '/vshow/aiWorks',
    //   child: [],
    //   parentKey: 'knowledgeManage',
    //   label: lang('mainMenu.workManagement.drawWorks'),
    //   visible: true,
    // },
    // {
    //   icon: 'iconfont icon-dianshangzuopin',
    //   title: lang('mainMenu.workManagement.aiECommerceAssistant'),
    //   bgColor: BG_BLUE,
    //   key: 'aiECommerceAssistant',
    //   url: '/vshow/aiECommerceCreations',
    //   child: [],
    //   parentKey: 'knowledgeManage',
    //   label: lang('mainMenu.workManagement.aiECommerceAssistant'),
    //   visible: true,
    // },
    // {
    //   icon: 'iconfont icon-taiben',
    //   title: lang('mainMenu.workManagement.dramaWorks'),
    //   bgColor: BG_YELLOW,
    //   key: 'scriptCreation',
    //   url: '/vshow/creations/playscript',
    //   child: [],
    //   parentKey: 'knowledgeManage',
    //   label: lang('mainMenu.workManagement.dramaWorks'),
    //   visible: true,
    // },
  ],
}
export const mockParentMenu = [
  {
    icon: 'iconfont icon-moteshichang',
    title: lang('mainMenu.firstMenu.home'),
    key: 'home',
    url: '/vshow/newHomePage',
    child: [],
    parentKey: '',
    label: lang('mainMenu.firstMenu.home'),
    visible: true,
  },
  // {
  //   icon: 'iconfont icon-moban-p',
  //   title: lang('mainMenu.firstMenu.templateMarket'),
  //   key: 'templateMarket',
  //   url: '/vshow/discover',
  //   child: [],
  //   parentKey: '',
  //   label: lang('mainMenu.firstMenu.templateMarket'),
  //   visible: true,
  // },
  // {
  //   icon: 'iconfont icon-yuyinshichang',
  //   title: lang('mainMenu.firstMenu.voiceMarket'),
  //   key: 'ttsMarket',
  //   url: '/vshow/ttsMarket',
  //   child: [],
  //   parentKey: '',
  //   label: lang('mainMenu.firstMenu.voiceMarket'),
  //   visible: true,
  // },
  // {
  //   icon: 'iconfont icon-taibenshichang',
  //   title: lang('mainMenu.firstMenu.dramaMarket'),
  //   key: 'dramaMarket',
  //   url: '/vshow/dramaMarket',
  //   child: [],
  //   parentKey: '',
  //   label: lang('mainMenu.firstMenu.dramaMarket'),
  //   visible: true,
  // },
  {
    icon: 'iconfont icon-gongzuotai1',
    title: lang('mainMenu.firstMenu.workBench'),
    key: 'workBench',
    url: '/vshow/workBench/newBench',
    child: [],
    parentKey: '',
    label: lang('mainMenu.firstMenu.workBench'),
    visible: true,
  },
  {
    icon: 'iconfont icon-moteshichang',
    title: lang('mainMenu.firstMenu.digitalMarket'),
    key: 'digitalMarket',
    url: '/vshow/digitalMarket',
    child: [],
    parentKey: '',
    label: lang('mainMenu.firstMenu.digitalMarket'),
    visible: true,
  },
  {
    icon: 'iconfont icon-zuopin1',
    title: lang('mainMenu.firstMenu.workManagement'),
    key: 'knowledgeManage',
    url: '/vshow/creations',
    child: [],
    parentKey: '',
    label: lang('mainMenu.firstMenu.workManagement'),
    visible: true,
  },
  {
    icon: 'iconfont icon-wode1',
    title: lang('mainMenu.firstMenu.myMenu'),
    key: 'system',
    url: '',
    child: [],
    parentKey: '',
    label: lang('mainMenu.firstMenu.myMenu'),
    visible: true,
  },
]
